import React, { useState } from "react";
import { useRef } from "react";
import "./Testimonials.css";
import profile from "./images/profile.jpg";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Testimonials = () => {

  const reviews = [
    {
      name: "Ajay S.",
      text: "Excellent service! Our home is pest-free, thanks to their professional and timely treatment.",
    },
    {
      name: "Sushil Sahu",
      text: "Good and fantastic service, prompt response, reliable, faithful and quality services.",
    },
    {
      name: "Dushyant Potdar",
      text: "It was a nice experience at my office and home after consultation with Total Pest Control.",
    },
    {
      name: "Manisha Patekar",
      text: "Best service by team. Absolutely effective pest control work.",
    },
    {
      name: "Suren Kakade",
      text: "We have got good experience of quality service by Total Pest Control.",
    },
    {
      name: "Ghuge Bhanudas",
      text: "Best pest control service in Pune for bedbugs. Highly recommended.",
    },
  ];

  const [index, setIndex] = useState(0);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].screenX;
  };

  const handleTouchEnd = (e) => {

    touchEndX.current = e.changedTouches[0].screenX;

    if (touchStartX.current - touchEndX.current > 50) {
      nextSlide();
    }

    if (touchEndX.current - touchStartX.current > 50) {
      prevSlide();
    }

  };

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };



  return (
    <div className="testimonial-section">

      <div className="container text-center">

        <h2 className="title">— Voices of Satisfaction —</h2>
        <p className="sub">Based on real customer reviews</p>

        <div className="slider"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >

          <div
            className="slider-track"
            style={{
              transform:
                window.innerWidth <= 768
                  ? `translateX(calc(-${index} * (78% + 28px)))`
                  : `translateX(-${index * 72}%)`
            }}
          >

            {reviews.map((item, i) => (
              <div className="testimonial-card" key={i}>

                <div className="quote">❝</div>

                <div className="stars">★★★★★</div>

                <p>{item.text}</p>

                <div className="user">
                  <img src={profile} alt="" />
                  <h6>{item.name}</h6>
                </div>

              </div>
            ))}
          </div>

        </div>

        {/* ARROWS */}
        <button className="arrow left" onClick={prevSlide}>
          <IoIosArrowBack />
        </button>

        <button className="arrow right" onClick={nextSlide}>
          <IoIosArrowForward />
        </button>
      </div>

    </div>
  );
};

export default Testimonials;